import React from 'react';
import {useParams} from 'react-router-dom';
import {
  useAccountPoolQuery,
  ClientPreleadCustomizeItem,
  useUpdateAccountCustomizeItemTextMutation,
} from 'api';

export default ({item}: {item: ClientPreleadCustomizeItem}) => {
  const {accountId} = useParams<{accountId: string}>();
  const {data: {accountPool: {account = {}} = {}} = {}} = useAccountPoolQuery({
    variables: {uuid: accountId},
    skip: !accountId,
  });
  const [update] = useUpdateAccountCustomizeItemTextMutation({});

  return (
    <textarea
      className="rounded p-2 w-60 focus:outline-none focus:outline-[#E6E6E6] focus:outline-1"
      rows={3}
      data-1p-ignore
      defaultValue={
        account?.customizeItemPayload
          ? account?.customizeItemPayload[item.id]
          : ''
      }
      onBlur={(e) => {
        update({
          variables: {
            uuid: account?.uuid,
            clientPreleadCustomizeItemId: item.id,
            value: e.target.value ? e.target.value : null,
          },
        });
      }}
    />
  );
};
